import script from "./LoansToRefinanceTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoansToRefinanceTable.vue?vue&type=script&setup=true&lang=ts"

import "./LoansToRefinanceTable.vue?vue&type=style&index=0&id=9b05d624&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b05d624"]])

export default __exports__